import React from 'react';
import { Progress } from 'reactstrap';
import { getStarNumberForValue, getSuccessNumberForValue } from '../../Views/ConstRatingBtns';
import { NothingEntered } from './DisplayUserText';

export function StarRating(props){
  const numStars = getStarNumberForValue(props.starRating);
  const maxStars = 5;
  const yellowStar = "/images/star.svg";
  const emptyStar = "/images/star-outline.svg";

  if ((props.starRating) && (numStars<=5)){
    return(
      <div className="aa-star-display">
        {Array(numStars).fill(null).map((value, index) => (
          <img key={index} src={yellowStar} alt="colored star"/>
        ))} 
        {Array(maxStars-numStars).fill(null).map((value, index) => (
          <img key={index+"e"} className="aa-empty-star" src={emptyStar} alt="empty star"/>
        ))} 
      </div>
    );
  }
  else return <NothingEntered />;
}

export function SuccessRating(props){
  //success 0 to 100 value
  const successNumber = getSuccessNumberForValue(props.successRating);
  if ((props.successRating) && successNumber!=null){
    return(<Progress 
      value={successNumber}
      color="success"
      >
        {successNumber+"%"}
      </Progress>
    );
  }
  else return <NothingEntered />;
}
